import './Information.css';

export default function Information() {
  return (
    <div className="page info-page">
      <h1>Informationen</h1>
      <p className="info-subtitle">Wissenswertes zu Salerno Roleplay</p>

      <div className="info-intro">
        <p>
          Wissenswertes zu Salerno Roleplay erklärt, was unseren Server ausmacht: Wie wir Roleplay verstehen,
          welche Regeln und Features wir anbieten und wie du Teil unserer Community wirst.
          Kurz: Salerno Roleplay ist ein deutschsprachiger GTA-V-FiveM-Server mit Fokus auf Realismus, Community und fairem RP.
        </p>
      </div>

      <div className="info-sections">
        <div className="info-section-card">
          <h2>Unsere Philosophie</h2>
          <div className="info-section-body">
            <p>
              Salerno Roleplay verbindet Charakterarbeit, Community und klare Regeln zu einem einzigartigen Roleplay-Erlebnis.
              Unser Ziel ist eine lebendige Spielwelt, in der Geschichten gemeinsam entstehen — ohne Pay-to-Win, ohne willkürliche Regeln.
            </p>
            <p>
              Roleplay lebt von Respekt, nachvollziehbarem IC-Verhalten und transparenten Entscheidungen.
              Deshalb setzen wir auf strenge aber faire Regelwerk zu RDM, VDM, IC/OOC und Powergaming — und auf eine aktive Community, die diese Werte lebt.
            </p>
            <p>
              Daten und Statistiken sollen nachvollziehbar bleiben: Serverdaten, Stream-Listen und Voting basieren auf echten Signalen
              und Community-Feedback — nicht auf anonymen Bewertungen oder bezahltem Marketing.
            </p>
          </div>
        </div>

        <div className="info-section-card">
          <h2>Server & Features</h2>
          <div className="info-section-body">
            <p>
              Unser Ziel ist es, einen stabilen, unterhaltsamen und fairen Roleplay-Server zu bieten.
              Mit detaillierten Jobs, Fraktionen, Economy-Systemen und aktiven Events möchten wir dir das bestmögliche RP-Erlebnis bieten.
              So findest du immer spannende Geschichten und Mitspieler.
            </p>
          </div>
        </div>

        <div className="info-section-card">
          <h2>Community & Entwicklung</h2>
          <div className="info-section-body">
            <p>
              Die Zukunft bringt neue Jobs, Features und Verbesserungen — entwickelt gemeinsam mit der Community.
              Eine lebendige Plattform für Roleplay-Enthusiasten. Mit interaktiven Features und persönlicher Betreuung wird dein
              Salerno-Erlebnis noch intensiver. Gemeinsam gestalten wir die Zukunft von Salerno Roleplay.
            </p>
          </div>
        </div>

        <div className="info-section-card">
          <h2>Die Technik</h2>
          <div className="info-section-body">
            <p>
              In Bezug auf die Technik beziehen wir alle Stream-Daten live aus der Twitch API und aktualisieren die
              Statistiken regelmäßig. Dies ermöglicht es dir, stets aktuelle Live-Streams und Serverdaten zu verfolgen.
            </p>
            <p>
              Unsere moderne Technologie ermöglicht es uns, eine nahtlose und performante Erfahrung zu bieten.
            </p>

            <h3>Frontend-Technologien</h3>
            <ul className="info-list-bullet">
              <li>React</li>
              <li>Vite</li>
              <li>CSS Modules</li>
              <li>Axios</li>
            </ul>

            <h3>Backend-Technologien</h3>
            <ul className="info-list-bullet">
              <li>Node.js</li>
              <li>Express</li>
              <li>MySQL</li>
              <li>Twitch API</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
